// extracted by mini-css-extract-plugin
export default {"entryCol":"Updates_entryCol__DBmcl","dateCol":"Updates_dateCol__26ngn","inlineSpinner":"Updates_inlineSpinner__if2me"};